/**
 * Waits for a variable to become defined/available.
 * - Checks every 100 ms for variable presence.
 *
 * @param {string} variable - Variable name to wait for
 * @param {integer} [timeout=2000] - Duration to wait in ms
 * @return {Promise} Promise object represents boolean presence of variable
 *
 * @example
 * import { definitionOf } from 'classes/async-helpers'
 *
 * async testThis() {
 *   try {
 *     await definitionOf('debugging', 10000) // wait 10s before failing
 *   } catch (error) {
 *     console.log('debugging never became available :(')
 *     return
 *   }
 *
 *   console.log(`debugging now exists! - ${debugging}`)
 * }
 */
export function definitionOf(variable, timeout = 2000) {
  /* global Promise */
  return new Promise((resolve, reject) => {
    const check = () => {
      if (typeof(window[variable]) !== 'undefined') {
        resolve(true)
      } else if ((timeout -= 100) <= 0) {
        reject(new Error('timed out'))
      } else {
        setTimeout(check, 100)
      }
    }

    setTimeout(check, 100)
  })
}
